<script setup>
import { computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { hydrateMfComponents } from './hydrate-mf-components';
import { resolveHtmlMediaUrls } from './media-lookup';

const props = defineProps({
    htmlContent: { type: String, default: '' },
    containerRef: { type: String, default: '' },
    mediaEntryMap: { type: Object, default: () => ({}) },
});

const contentRef = ref(null);
const currentInstance = getCurrentInstance();
let cleanupHydratedContent = null;
const resolvedHtmlContent = computed(() => resolveHtmlMediaUrls(props.htmlContent, props.mediaEntryMap));

const unmountHydratedComponents = () => {
    cleanupHydratedContent?.();
    cleanupHydratedContent = null;
};

const hydrateComponents = async () => {
    if (!contentRef.value) return;

    unmountHydratedComponents();

    cleanupHydratedContent = hydrateMfComponents(contentRef.value, {
        appContext: currentInstance?.appContext,
        containerRef: props.containerRef,
        mediaEntryMap: props.mediaEntryMap,
    });
};

const scheduleHydration = () => nextTick(hydrateComponents);

watch([resolvedHtmlContent, () => props.mediaEntryMap], scheduleHydration, { flush: 'post', deep: true });

onMounted(scheduleHydration);
onBeforeUnmount(unmountHydratedComponents);
</script>

<template>
    <div ref="contentRef" v-html="resolvedHtmlContent"></div>
</template>
